import { render } from "./PermisosView.vue?vue&type=template&id=84e26e60&scoped=true"
import script from "./PermisosView.vue?vue&type=script&lang=js"
export * from "./PermisosView.vue?vue&type=script&lang=js"

import "./PermisosView.vue?vue&type=style&index=0&id=84e26e60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e26e60"]])

export default __exports__